import { render } from "./ItemAccessories.vue?vue&type=template&id=5823988f&scoped=true"
import script from "./ItemAccessories.vue?vue&type=script&lang=js"
export * from "./ItemAccessories.vue?vue&type=script&lang=js"

import "./ItemAccessories.vue?vue&type=style&index=0&id=5823988f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5823988f"]])

export default __exports__